import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { MEETING_ACTION_ITEMS_FILTER_OPTIONS } from '../../../constants/meetingActionItemsFilter';

/**
 * MeetingActionItemsFilterSelector - A dropdown selector for filtering meetings by action items
 *
 * @param {string} value - The selected filter value
 * @param {Function} onChange - Callback when selection changes (value) => void
 * @param {boolean} disabled - Whether the selector is disabled
 * @param {string} label - Label for the selector
 * @param {string} size - Size of the select ('small' | 'medium')
 * @param {number} minWidth - Minimum width in pixels
 * @param {Object} sx - Additional styles for the FormControl
 */
const MeetingActionItemsFilterSelector = ({
  value = '',
  onChange,
  disabled = false,
  label = 'Action Items',
  size = 'small',
  minWidth = 180,
  sx = {},
}) => {
  return (
    <FormControl size={size} sx={{ minWidth, ...sx }} disabled={disabled}>
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        label={label}
      >
        {MEETING_ACTION_ITEMS_FILTER_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MeetingActionItemsFilterSelector;
